'use client';

import * as Dialog from '@radix-ui/react-dialog';
import { CircleX } from 'lucide-react';

import { caixaStd } from '@/app/tag-com-beneficios-caixa/fonts';
import { WHATSAPP_LINK } from '@/constants/whatsapp';

const CONTATOS = [
  {
    rotulo: 'Capitais e Regiões Metropolitanas:',
    numero: '3003 9590',
    href: 'tel:30039590',
  },
  {
    rotulo: 'Demais localidades:',
    numero: '0800 721 9590',
    href: 'tel:08007219590',
  },
  {
    rotulo: 'WhatsApp | Vendas:',
    numero: '11 5128 8893',
    href: WHATSAPP_LINK,
  },
];

const HORARIOS = [
  {
    horario: '9h às 18h de segunda à sexta-feira',
    observacao: '(todos os produtos da CAIXA Pré Pagos)',
  },
  {
    horario: '9h às 15h aos sábados',
    observacao: '(somente para clientes tagCAIXA)',
  },
];

export function FaleConoscoModal() {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button type="button" className="cursor-pointer text-left">
          Fale Conosco
        </button>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[80] bg-black/70 data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          className={`${caixaStd.variable} fixed left-1/2 top-1/2 z-[80] max-h-[85vh] w-[calc(100vw-32px)] max-w-[480px] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-2xl bg-white p-6 font-[family-name:var(--font-caixa-std)] shadow-lg duration-200 data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 min-[760px]:p-8`}
        >
          <Dialog.Title className="pr-8 text-[20px] font-bold leading-[1.4] text-[#1561AC] min-[760px]:text-[24px]">
            Fale Conosco
          </Dialog.Title>
          <Dialog.Description className="mt-1 text-[15px] leading-[1.6] text-[#5A6B80]">
            Central de atendimento CAIXA Pré-Pagos.
          </Dialog.Description>

          <ul className="mt-6 flex flex-col gap-5">
            {CONTATOS.map(({ rotulo, numero, href }) => (
              <li key={rotulo}>
                <p className="text-[15px] text-[#5A6B80]">{rotulo}</p>
                <a
                  href={href}
                  target={href.startsWith('tel:') ? undefined : '_blank'}
                  rel="noopener noreferrer"
                  className="text-[24px] font-bold text-[#46536B] hover:text-[#1561AC]"
                >
                  {numero}
                </a>
              </li>
            ))}
          </ul>

          <div className="mt-6 border-t border-[#E3E8EF] pt-5">
            <p className="text-[15px] text-[#5A6B80]">
              Horário de atendimento:
            </p>
            {HORARIOS.map(({ horario, observacao }) => (
              <p
                key={horario}
                className="mt-1 text-[16px] leading-[1.5] text-[#46536B]"
              >
                <span className="font-bold">{horario}</span> {observacao}
              </p>
            ))}
          </div>

          <Dialog.Close
            aria-label="Fechar"
            className="absolute right-4 top-4 cursor-pointer text-[#5A6B80] transition-opacity hover:opacity-70"
          >
            <CircleX className="h-6 w-6" />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
